import {
  BalancePayAction,
  BalancePayState,
  OpenAction,
  SetActiveAction,
} from './interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import { CurrencyEnum } from '$store/models';
import { getStorageItem, setStorageItem } from '$utils';

const initialState: BalancePayState = {
  isActive: false,
  action: null,
  amount: 0,
  objectId: null,
  currency: CurrencyEnum.EUR,
  extraId: 0,
  isAnon: false,
  period: 0,
};

export const { actions, reducer } = createSlice({
  name: 'balancePay',
  initialState,
  reducers: {
    setActive(state, action: SetActiveAction) {
      state.isActive = action.payload;
    },
    open(state, action: OpenAction) {
      state.isActive = true;
      state.action = action.payload.action;
      state.amount = action.payload.amount;
      state.objectId = action.payload.objectId;
      state.currency = action.payload.currency || CurrencyEnum.EUR;
      state.extraId = action.payload.extraId ?? 0;
      state.isAnon = action.payload.isAnon ?? false;
      state.period = action.payload.period ?? 0;
    },
    reopen(state) {
      if (state.action) {
        state.isActive = true;
      }
    },
    close(state) {
      state.isActive = false;
    },
    getRates() {},
    clearContext() {
      return initialState;
    },
    saveContext(state) {
      setStorageItem('balancePay', JSON.stringify(state));
    },
    restoreContext(state) {
      const savedState = JSON.parse(getStorageItem('balancePay') || '{}');
      if (savedState.action) {
        return {
          ...state,
          ...savedState,
          isActive: true,
        };
      }
      return state;
    },
  },
});

export { reducer as balancePayReducer, actions as balancePayActions };
export const balancePaySelector = (state: RootState) => state.balancePay;
